import { Injectable } from '@angular/core';
import { TabVm } from 'qp-ui-interface';
import { Subject } from 'rxjs';
import { addClientTabs, getTabIcon } from '../../utils/tabsUtils';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  private _tabsUpdated = new Subject<void>();
  public tabsLoaded = false;
  public tabsInfo: TabVm[] = [];
  private currenttabid = '';
  private currenttabname = '';

  get currentTabId(): string {
    return this.currenttabid || this.tabsInfo?.[0]?.id;
  }

  set currentTabId(tabId: string) {
    this.currenttabid = tabId;
  }

  get currentTabName(): string {
    return this.currenttabname || this.tabsInfo?.[0]?.name;
  }

  set currentTabName(tabName: string) {
    this.currenttabname = tabName;
  }

  get tabsUpdated() {
    return this._tabsUpdated.asObservable();
  }

  setTabs(tabs: TabVm[]): void {
    this.tabsInfo = tabs.map((tab) => ({ ...tab, icon: getTabIcon(tab.data) }));
    this.tabsInfo = addClientTabs(this.tabsInfo);
    this.tabsLoaded = true;
    this._tabsUpdated.next();
  }

  getTabs(): TabVm[] {
    return this.tabsInfo;
  }

  getCurrentTab(): TabVm {
    if (!this.tabsInfo) return undefined;
    if (this.tabsInfo.length === 0) return undefined;
    const currentTabId = this.currenttabid || this.tabsInfo[1].id;
    return this.tabsInfo?.find((element) => element.id === currentTabId);
  }

  getTab(tabId: string): TabVm {
    if (!this.tabsInfo) return undefined;
    if (this.tabsInfo.length === 0) return undefined;
    const currentTabId = tabId || this.tabsInfo[0].id;
    return this.tabsInfo.find((element) => element.id === currentTabId);
  }
}
